/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PreregisteredUserViewModel } from './PreregisteredUserViewModel'; 

export function getPreregisteredUserOptions(onSuccess?: (result: PreregisteredUserViewModel) => void) {
	return queryOptions({
		queryKey: ['preregistered-user'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/users/queries/getpreregistereduser/';
			const resp = await axios.get<PreregisteredUserViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}